// 业务用户相关工具
import { validate } from "@/config";
import { Toast } from "vant";

// 针对表单进行正则验证
/**
 * 
 * @param {Object} form 需要提交的表单
 * @param {key.字段名, type.验证类型, hint.错误提示} mode 表单中每个字段对应的正则类型，错误提示
 * @returns {true.验证成功 false.验证失败}
 */
export const regexpVerify = (form, mode) => {
  return new Promise((resolve, reject) => {
    mode.map(item => {
      if (!form[item.key]) {
        Toast(item.hint);
        reject();
      }
      if (item.type) {
        let reg = new RegExp(validate[item.type]);
        if (!reg.test(form[item.key])) {
          Toast(item.hint);
          reject();
        }
      }
    })
    resolve();
  })
}